import {TypedUseSelectorHook, useSelector} from 'react-redux';
import {TAppRootState} from 'core/redux/types';

export const useAppSelector: TypedUseSelectorHook<TAppRootState> = useSelector;
